<template>
  <!-- 表单数组列表 -->
  <div class="cmp-form-list mb-20">
    <div class="list" v-for="(item, index) in dataList" :key="index">
      <div class="title mb-20">
        {{item.label+(index+1)}}
        <span class="btn-dele fr" @click="remove(index)" v-if="index>0"></span>
      </div>
      <el-form
        class="g-form-grid"
        :model="formDetail[index]"
        :ref="`detailForm`+index"
        :label-width="item.fieldsLabelWidth || '110px'"
      >
        <cmpFormItem
          v-for="(it, i) in item.arr"
          :key="i"
          :itemData="it"
          :form="formDetail[index]"
          @calcFun="calcFun"
          :isDisable="isDisable"
        ></cmpFormItem>
      </el-form>
    </div>
    <span class="m-btn" @click="add" v-if="!isDisable">
      <svg-icon icon-class="add"/>&nbsp;添加明细
    </span>
  </div>
</template>

<script>
import { validate } from '@/utils/util'
import cmpFormItem from '@cmp/form/item'
export default {
  components: { cmpFormItem },
  props: {
    detailObj: {
      type: Array,
      default() {
        return []
      }
    },
    isDisable: {
      type: Boolean,
      default: false
    }
    // formDetail: {
    //   type: Array,
    //   default() {
    //     return []
    //   }
    // }
  },
  computed: {
    dataList() {
      return this.detailObj
    }
  },
  data() {
    return {
      formDetail: [{}]
    }
  },
  methods: {
    init() {
      this.clearFormValid()
    },
    add() {
      this.dataList.push(this.dataList[0])
      this.formDetail.push({})
    },
    remove(index) {
      this.dataList.splice(index, 1)
      this.formDetail.splice(index, 1)
    },
    // 获取明细列表
    getFormList() {
      return this.formDetail
    },
    // 计算总金额
    calcFun(aboutName, name) {
      // 发现有不是数字的金额，校验不通过
      let isValidPass = this.formDetail.some(item => {
        return !validate(item[name], 'numDecimal')
      })
      if (isValidPass) return

      let total = 0
      this.formDetail.forEach(item => {
        // total += Number(item[name])
        total = parseInt((total + parseFloat(item[name] || 0)) * 100, 10) / 100
      })
      this.$emit('setCalc', aboutName, total)
    },
    isValidate() {
      let isFormValid = true
      this.dataList.forEach((item, index) => {
        if (!this.checkForm('detailForm' + index)) {
          isFormValid = false
        }
      })
      return isFormValid
    },
    // 表单校验
    checkForm(form) {
      let isValid = true
      this.$refs[form][0].validate(valid => {
        if (valid) {
          isValid = true
        } else {
          isValid = false
        }
      })
      return isValid
    },
    // 重置表单
    clearFormValid() {
      this.$nextTick(() => {
        this.dataList.forEach((item, index) => {
          for (let key in this.formDetail[index]) {
            this.$set(this.formDetail[index], key, '')
          }
          this.$refs['detailForm' + index][0].clearValidate()
          // this.$refs['detailForm' + index][0].resetFields()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cmp-form-list {
  .title {
    padding: 10px 0;
    border-bottom: solid 1px $border;
  }
  .btn-dele {
    display: inline-block;
    margin-top: 3px;
    width: 14px;
    height: 14px;
    background: url(~@images/btn-dele.svg) center center no-repeat;
    cursor: pointer;
    &:hover {
      background: url(~@images/btn-dele-active.svg) center center no-repeat;
    }
  }
}
</style>


